import Auth from '../Auth'

import Model from './Model'
import Project from './Project'
import AgencyProfilePage from "../views/profiles/AgencyProfilePage";
import HasMatching from "./decorators/HasMatching";
import User from "./User";
import Discipline from "./Discipline";
import IsCandidate from "./decorators/IsCandidate";
import ProjectPhase from "./ProjectPhase";
import UserDiscipline from "./UserDiscipline";
import Opportunity from "./Opportunity";

const numeral = require('numeral');

const SortOptions = {
    KeySkills: 'Key Skills',
    Availability: 'Availability',
    Experience: 'Total Experience',
    IndustryExperience: 'Industry Experience',
    Rate: 'Bill Rate',
    Location: 'Location',
};

const ORIENTATION = {
    COLUMN: 'COLUMN',
    CARD: 'CARD',
}
export default class Agency extends IsCandidate(HasMatching(Model)) {
    static LAYOUTS = ORIENTATION;
    static Key = 'Agency';

    static SortOptions = SortOptions;

    static normalize(props) {

        if (props.positions) {
            console.log('normalizeAgency', props.positions?.length);
            props.positions = TB.map(props.positions, pos => {
                let {
                    user,
                    ...posProps
                } = {...pos}
                if (user) {
                    posProps = {...posProps,...(user || {})}
                }
                posProps.disciplines = TB.filter(TB.map(posProps.disciplines, discipline => {
                    let disciplineName = discipline?.discipline?.name;
                    if (!disciplineName && discipline.discipline_id) {
                        let lookup = Discipline.find(discipline.discipline_id) || {}
                        disciplineName = lookup?.name
                    }
                    if (!disciplineName) return null;


                    return {
                        ...discipline,
                        name: disciplineName
                    }
                }), dis => !!dis)


                return User.make({...posProps})
            })
        }

        if (props.job_candidate?.talent_opps) {
            props.job_candidate.talent_opps = TB.map([...props.job_candidate.talent_opps], opp => {
                if (opp.user) {
                    const matchPosition = TB.find(props.positions, ['id', opp.user?.id]) || {};

                    opp.user = User.make({...matchPosition, ...(opp.user || {})});
                }else {
                    const matchPosition = TB.find(props.positions, ['id', opp.id]) || {};

                    opp.user = User.make({...matchPosition, ...opp});
                    delete opp.first_name;
                    delete opp.last_name;
                    delete opp.name;
                }

                let disciplines = TB.map([...(opp.disciplines || [])], discipline => {

                    const proposed_hourly_rate = discipline.proposed_hourly_rate ? parseFloat(discipline.proposed_hourly_rate || discipline.hourly_rate) : null;
                    const proposed_total_periods = discipline.proposed_total_periods ? parseInt(discipline.proposed_total_periods || discipline.total_hours) : null;

                    const matches_hourly_rate= !discipline.proposed_hourly_rate || parseFloat(discipline.hourly_rate) === parseFloat(proposed_hourly_rate);

                    const matches_total_periods = !discipline.proposed_total_periods || parseInt(discipline.total_hours) === parseInt(proposed_total_periods);
                    return {
                        ...discipline,
                        proposed_hourly_rate,
                        proposed_total_periods,
                        // payout_amount: parseFloat(discipline.hourly_rate) * parseInt(discipline.total_hours),
                        // proposed_payout_amount: parseFloat(proposed_hourly_rate) * parseInt(proposed_total_periods),
                        matches_hourly_rate,
                        matches_total_periods,
                        matches_payout: matches_hourly_rate && matches_total_periods,
                    }
                })
                // const scopedHours = TB.sumBy(opp.disciplines, 'total_hours')
                // const proposedHours = TB.sumBy(opp.disciplines, disc => disc.proposed_total_periods || disc.total_hours)
                // const rates = TB.map(opp.disciplines, 'hourly_rate')
                // const scopedMaxRate = TB.max(rates)
                // const scopedMinRate = TB.min(rates)
                // const scopedRate = scopedMinRate === scopedMaxRate ? `$${TB.formatNumber(scopedMinRate, 2)}/hr` :
                //     `$${TB.formatNumber(scopedMinRate, 2)}-${TB.formatNumber(scopedMaxRate, 2)}/hr`
                // const proposedRates = TB.map(opp.disciplines, disc => disc.proposed_hourly_rate || disc.hourly_rate)
                // const proposedMaxRate = TB.max(proposedRates)
                // const proposedMinRate = TB.min(proposedRates)
                // const proposedRate = proposedMinRate === proposedMaxRate ? `$${TB.formatNumber(proposedMaxRate, 2)}/hr` :
                //     `$${TB.formatNumber(proposedMinRate, 2)}-${TB.formatNumber(proposedMaxRate, 2)}/hr`

                return Opportunity.make({
                    ...opp,
                    disciplines,
                })
            })
            let activeOpps = TB.filter(props.job_candidate.talent_opps, opp => opp.status !== Opportunity.Statuses.Lost);
            props.total_talent_opps = activeOpps.length;
            props.total_accepted_talent_opps = 0;
            props.total_proposed_talent_opps = 0;
            props.total_rejected_talent_opps = 0;
            props.total_withdrawn_talent_opps = 0;
            props.total_pending_talent_opps = 0;
            TB.map(activeOpps, opp => {
                if(!!opp.withdrew_at) {
                    props.total_withdrawn_talent_opps += 1;
                }else if(!!opp.rejected_at) {
                    props.total_rejected_talent_opps += 1;
                }else if(!!opp.accepted_at) {
                    const hasProposedPayout = TB.find(opp.disciplines, ['matches_payout', false]);
                    if (hasProposedPayout) {
                        props.total_proposed_talent_opps += 1;
                    }else {
                        props.total_accepted_talent_opps += 1;
                    }
                }else {
                    props.total_pending_talent_opps += 1;
                }
            });
            // props.total_proposed_talent_opps = TB.filter(props.job_candidate.talent_opps, opp => {
            //     return !!opp.accepted_at && !opp.withdrew_at && !opp.rejected_at
            // }).length;
            // props.total_rejected_talent_opps = TB.filter(props.job_candidate.talent_opps, opp => {
            //     return !!opp.rejected_at && !opp.withdrew_at
            // }).length;
            // props.total_withdrawn_talent_opps = TB.filter(props.job_candidate.talent_opps, opp => {
            //     return !!opp.withdrew_at
            // }).length;
            // props.total_pending_talent_opps = TB.filter(props.job_candidate.talent_opps, opp => {
            //     return !opp.accepted_at && !opp.withdrew_at && !opp.rejected_at
            // }).length;
        }

        if (props.job_candidate?.proposal_path && !props.latest_proposal) {
            props.latest_proposal = props.job_candidate?.proposal_path;
        }

        if (props.key_clients) {
            let keyClientBrands = TB.flatMap(props.key_clients, 'brands');
            props.brands = [...(props.brands || []), ...keyClientBrands];
        }
        return props;
    }

    /*
    |--------------------------------------------------------------------------
    | Candidate Matching
    |--------------------------------------------------------------------------
    */

    profilePage(params) {
        let pathname = `/agency-profiles/${this.id}`;
        let search = '';
        if (params) {
            search = '?' + Object.keys(
                params
            ).map(
                key => key + '=' + params[key]
            ).join('&');
        }
        return {
            pathname, search
        };
    }

    leads() {
        return TB.filter(
            this.positions, {is_lead: true}
        );
    }


    vipsForService(service) {
        let leads = this.leads(),
            positionLookup = TB.keyBy([...this.positions], 'discipline.id'),
            leadLookup = TB.keyBy(leads, 'discipline.id'),
            orderedDisciplines = TB.sortBy(
                service.disciplines, 'display_index'
            );

        // console.log('Agency @ vipsForService');
        // console.log('leads');
        // console.log(leads);
        // console.log('positionLookup');
        // console.log(positionLookup);

        let vips = [];
        for (let discipline of orderedDisciplines) {
            let lead = leadLookup[discipline.id];
            if (!lead) {
                lead = positionLookup[discipline.id];
            }
            vips.push(lead)

            if (vips.length >= 3) {
                break;
            }
        }

        return vips;
    }


    vipsForProject(project) {
        let leads = this.leads(),
            positionLookup = TB.keyBy([...this.positions], 'discipline.id'),
            leadLookup = TB.keyBy(leads, 'discipline.id'),
            orderedDisciplines = TB.sortBy(
                project.disciplines, 'display_index'
            );

        // console.log('Agency @ vipsForProject');
        // console.log('leads');
        // console.log(leads);
        // console.log('positionLookup');
        // console.log(positionLookup);

        let vips = [];
        for (let discipline of orderedDisciplines) {
            if (!discipline.is_required || !discipline.is_active) {
                continue;
            }

            let lead = leadLookup[discipline.id];
            if (!lead) {
                lead = positionLookup[discipline.id];
            }
            vips.push(lead)

            if (vips.length >= 3) {
                break;
            }
        }

        return vips;
    }

    nonVipsForProject(project) {
        let vips = this.vipsForProject(project);

        return TB.filter(this.positions, position => {
            for (let vip of vips) {
                if (vip && vip.id === position.id && vip.discipline.id === position.discipline.id) {
                    return false;
                }
            }

            return true;
        });
    }

    sortedPositions() {
        return TB.map(TB.orderBy(
            this.positions, ['is_lead', true]
        ), position => {
            if (!(position instanceof User)) {
                position = User.make({...position})
            }
            return position
        });
    }

    topPositionsForDisplay(project) {
        if (project) {
            return this.vipsForProject(project)
        }

        let ranked = TB.orderBy(
            this.positions, ['is_lead', true]
        );

        return TB.take(ranked, 3);
    }

    positionForUser(user) {
        return TB.find(this.positions, ['id', user.id])
    }

    fullBio() {
        if (!this.bio || !TB.stripHtml(this.bio)?.length) {
            return `<i>No background information provided</i>`
        }
        return this.bio
    }

    shortBio() {
        if (!this.bio || !TB.stripHtml(this.bio)?.length) {
            return;
        }

        return TB.stripHtml(this.bio).substr(0, 65);
    }

    formattedCoverLetter() {
        let letter = this.cover_letter;
        if (!letter) {
            return;
        }

        while (letter.includes("\n")) {
            letter = letter.replace("\n", '<br/>');
        }

        return letter;
    }

    /*
    |--------------------------------------------------------------------------
    | Cost Calculations
    |--------------------------------------------------------------------------
    */

    averageRateForDiscipline(disciplineId) {
        let memberDisciplines = TB.groupBy(
            this.positions, 'discipline.id'
        );

        let members = memberDisciplines[disciplineId];
        if (!members) {
            return;
        }

        return TB.meanBy(members, 'hourly_rate');
    }

    disciplineBulkEstimatesFor(project) {
        let disciplineTotals = project.disciplineHourlyTotals(),
            requiredDisciplines = project.requiredDisciplines(),
            requiredLookup = TB.keyBy(
                requiredDisciplines, 'id'
            ),
            disciplineLookup = TB.keyBy(
                this.positions, 'discipline.id'
            );

        let estimates = [];
        for (let disciplineId in disciplineTotals) {
            if (!requiredLookup[disciplineId]) {
                continue;
            }

            let hourlyRate = this.averageRateForDiscipline(
                disciplineId
            );
            if (!hourlyRate) {
                return;
            }

            let discipline = disciplineLookup[disciplineId].discipline;

            estimates.push({
                id: disciplineId,
                name: discipline.name,
                hourly_rate: hourlyRate,
                total_hours: disciplineTotals[disciplineId],
                estimate: hourlyRate * disciplineTotals[disciplineId],
            });
        }

        return estimates;
    }

    rangedPlatformRates(showCurrencyForRange = false) {

        let disciplines = this.matching?.disciplines?.disciplines || [];
        if (!this.hasMatching() || !this.matching.disciplines?.disciplines?.length) {
            if ((!this.hasMatching() || !this.matching.disciplines?.disciplines?.length) && this.positions) {
                disciplines = TB.flatMap(this.positions, 'disciplines');
            }
        }
        if (!disciplines.length) {

            return TB.formatCurrency(100);
        }

        let discipline_rates = TB.map(disciplines, 'hourly_rate');

        let minRate = parseFloat(TB.min(discipline_rates));
        let maxRate = parseFloat(TB.max(discipline_rates));
        let avgRate = parseFloat(TB.mean(discipline_rates));
        minRate = Math.round(minRate);
        maxRate = Math.round(maxRate);
        avgRate = Math.round(avgRate);
        if (maxRate && minRate && maxRate !== minRate) {
            return showCurrencyForRange ? `${TB.formatCurrency(minRate)} - ${TB.formatCurrency(maxRate)}` : `${TB.formatCurrency(minRate)}-${TB.formatNumber(maxRate)}`
        } else if (!maxRate && minRate) {
            return TB.formatCurrency(minRate)
        } else if (!minRate && maxRate) {
            return TB.formatCurrency(maxRate)
        }
        return TB.formatCurrency(avgRate)
    }

    averageBillRate(format = true) {
        if (this.average_hourly_rate) {
            let rate = this.average_hourly_rate;

            if (!format) {
                return rate;
            }

            return TB.formatCurrency(
                rate
            );
        }

        let applicable = TB.filter(
            this.positions,
            position => parseFloat(position.hourly_rate) > 0
        );
        let rates = TB.map(
            applicable,
            position => parseFloat(position.hourly_rate)
        );

        let rate = TB.mean(rates);
        if (!rate) {
            return format ? '---' : null;
        }

        if (!format) {
            return rate;
        }

        return numeral(rate).format('($0)') + '/hr';
    }

    averageHourlyRateFor(project, format = true) {
        if (this.project && !this.project.hasRequiredDisciplines) {
            // return format ? '---' : null;
            return this.averageBillRate(format);
        }

        let totalHours = project.hourlyTotal(),
            total = this.estimated_cost;

        if (!totalHours || !total) {
            // return format ? '---' : null;
            return this.averageBillRate(format);
        }

        let rate = total / totalHours;

        if (!format) {
            return rate;
        }

        return numeral(rate).format('($0)') + '/hr';
    }

    estimateFor(project) {
        let disciplineCosts = this.disciplineBulkEstimatesFor(
            project
        );
        if (!disciplineCosts) {
            return;
        }

        return TB.sumBy(disciplineCosts, 'estimate');
    }

    serviceFeeFor(project) {
        let estimate = this.estimateFor(project);
        if (!estimate) {
            return;
        }

        return project.serviceFeeForEstimate(estimate);
    }

    estimateWithServiceFeeFor(project) {
        let estimate = this.estimateFor(project);
        if (!estimate) {
            return;
        }

        let fee = this.serviceFeeFor(project);
        if (!fee) {
            return estimate;
        }

        return fee + estimate;
    }

    /*
    |--------------------------------------------------------------------------
    | Metric Match Scoring
    |--------------------------------------------------------------------------
    */

    static defaultSortingOptionFor(project) {
        return this.SortOptions.Availability;
    }

    static sortingOptionsFor(project) {
        let options = {...this.SortOptions};
        // if (!project.hasSchedule()) {
        delete options.Availability;
        // }

        return TB.values(options);
    }

    static matchSortingOptions() {
        let options = {
            best_match: "Best Match (high to low)",
            min_bill_rate: 'Bill Rate (low to high)',
            max_bill_rate: 'Bill Rate (high to low)',
            experience: 'Total Experience (high to low)',
            key_skills: 'Key Skills (high to low)',
            industries: 'Industry Experience (high to low)',
            first_name: 'Agency Name (A-Z)',
        };
        if (TB.auth()?.user?.().clientOrg?.()?.location) {
            options.proximity = 'Location (near to far)'
        }
        return options
    }

    rankedSkills() {
        let skillCounts = {};

        for (let position of this.positions) {
            for (let skill of position.skills) {
                if (!skillCounts[skill.id]) {
                    skillCounts[skill.id] = {
                        id: skill.id,
                        name: skill.name,
                        ranks: [skill.self_score],
                    }
                } else {
                    skillCounts[skill.id].ranks.push(skill.self_score);
                }
            }
        }

        for (let id in skillCounts) {
            skillCounts[id].averageRank = TB.mean(
                skillCounts[id].ranks
            );
        }

        return TB.reverse(
            TB.sortBy(
                TB.values(skillCounts), 'averageRank'
            )
        );
    }

    experiencedIndustries() {
        let industryCounts = {};
        for (let position of this.positions) {
            for (let industry of position.industries_worked) {
                if (!industryCounts[industry.id]) {
                    industryCounts[industry.id] = {
                        id: industry.id,
                        name: industry.name,
                        scores: [industry.talent_score],
                    }
                } else {
                    industryCounts[industry.id].scores.push(
                        industry.talent_score
                    );
                }
            }
        }

        for (let id in industryCounts) {
            industryCounts[id].averageScore = TB.mean(
                industryCounts[id].scores
            );
        }

        return TB.reverse(
            TB.sortBy(
                TB.values(industryCounts), 'averageScore'
            )
        );
    }

    /*
    |--------------------------------------------------------------------------
    | Network Requests
    |--------------------------------------------------------------------------
    */

    static RequestProposalForProjectRequest;
    static CancelRequestProposalForProjectRequest;
    static RequestInterviewForProjectRequest;
    static AssignToProjectRequest;
    static UnassignFromProjectRequest;

    static AddToProjectShortlistRequest;
    static RemoveFromProjectShortlistRequest;

    static AddToFavoritesRequest;
    static RemoveFromFavoritesRequest;

    static AddToProjectArchiveRequest;
    static RemoveFromProjectArchiveRequest;

    static FetchAllMatchingProjectRequest;
    static FetchRequest;

    static async fetchMatchingProject(project, shouldCaptureRequest = false, forceRefresh = false) {
        project = Project.make({...project})

        if (!forceRefresh && !shouldCaptureRequest && this.Cached && this.Cached[project.id]) {
            return this.Cached[project.id];
        }

        let responseData = await this.runProjectRequest(
            project,
            'FetchAllMatchingProjectRequest',
            'get',
            `?capture_talent_request=${shouldCaptureRequest}`
        );

        if (!responseData
            || !responseData.agencys) {
            return;
        }

        let agencys = this.makeMany(
            responseData.agencys
        );

        return agencys;
    }

    static async find(agencyId, projectId, requestOptions = {}) {
        if (!agencyId) {
            throw new Error('Not Found')
        }
        let queryString = '';

        if (projectId) {
            queryString = `?project_id=${projectId}`;
        }

        return this.fetch(
            agencyId, queryString, requestOptions
        );
    }

    static async fetch(agencyId, params, requestOptions = {}) {
        this.FetchRequest = TB.request(
            TB.api_endpoint(`/api/agencys/${agencyId}`),
            params
        );

        let response = await this.FetchRequest.get(requestOptions).catch(console.warn);

        // console.log('Agency @ fetch -> response');
        // console.log(response);

        if (!response
            || !response.success
            || !response.success.data
            || !response.success.data.agency) {
            throw new Error('Something went wrong')
        }

        return this.make(
            response.success.data.agency
        );
    }

    static async fetchAgencyCandidateScope(candidateId, requestOptions = {}) {
        const fetchAgencyCandidateScopeRequest = TB.request(
            TB.api_endpoint(`/api/job-candidates/agencys/${candidateId}/scope`)
        );


        let response = await fetchAgencyCandidateScopeRequest.get(requestOptions).catch(console.warn);

        // console.log('Agency @ fetch -> response');
        // console.log(response);

        if (!TB.get(response, 'success.data.agency')) {
            throw new Error('Something went wrong')
        }

        let agency = {...response.success.data.agency };

        // if(agency.job_candidate) {
        //     agency.job_candidate.talent_opps = TB.map([...agency.job_candidate?.talent_opps], (opp) => {
        //         let userPosition = TB.find(agencyPositions, ['id', opp?.user?.id]);
        //
        //         if (userPosition) {
        //             opp.user = User.make({...opp.user, ...userPosition})
        //         }
        //         return opp
        //     })
        //
        // }
        return this.make({...agency})
    }

    static async runProjectRequest(project, requestProp, requestMethod, appendToUrl = '') {
        let user = Auth.user();
        if (!user
            || !user.hasRegisteredClientOrg()) {
            return;
        }

        project = Project.make({...project});

        this[requestProp] = TB.request(
            TB.api_endpoint(`/api/clients/${user.clientOrg().id}/projects/${project.id}/agency-candidates${appendToUrl}`)
        );

        let response = await this[requestProp][requestMethod]().catch(console.warn);

        if (!response
            || !response.success
            || !response.success.data) {
            this[requestProp].didHandleError = await this[requestProp].handleError();
            if (this[requestProp].didHandleError
                && this[requestProp].shouldRerun) {
                return this.runProjectRequest(
                    project, requestProp, requestMethod, appendToUrl
                );
            }

            return;
        }

        return response.success.data;
    }

    static SearchForClientRequest;

    static async searchForClient(params) {
        // console.log('Agency @ searchForClient', params);

        let user = TB.auth().user();
        if (!user
            || !user.hasRegisteredClientOrg()) {
            return;
        }
        let formattedParams = {};
        for (let [key, value] of Object.entries(params)) {
            if (TB.isArray(value)) {
                if (!value.length) {
                    continue;
                }
                value = value.join(',');
            }
            if (key === 'experience') {
                if (!formattedParams['experience']) {
                    formattedParams['experience'] = {}
                }
                try {
                    TB.map(value, (isChecked, key) => {
                        formattedParams['experience'][key] = isChecked ? 1 : 0;
                    })

                }catch (e) {
                    console.error(e);
                }
                continue;
            }
            formattedParams[key] = value;
        }

        this.SearchForClientRequest = TB.request(
            TB.api_endpoint(`/api/clients/${user.clientOrg().id}/agencys`), formattedParams
        );

        let response = await this.SearchForClientRequest.get().catch(console.warn);

        if (!TB.has(response, 'success.data.agencys')) {
            throw new Error('Something Went Wrong')
        }


        return TB.set(response.success.data, 'agencys', this.makeMany(response.success.data.agencys));
    }

    static SearchClientProjectsRequest;

    async searchProjectsForClient(search) {
        // console.log('fetchAllForTalentManager');
        let user = Auth.registeredClientUser();
        if (!user) {
            return;
        }

        await this.constructor.cancelRequest('SearchClientProjectsRequest')
        // console.log(formattedParams);
        this.constructor.SearchClientProjectsRequest = TB.request(
            TB.api_endpoint(`/api/clients/${TB.auth().user().clientOrg().id}/agencys/${this.id}/search`),
            {search: search}
        );

        let request = this.constructor.SearchClientProjectsRequest;

        let response = await request.get().catch(console.warn);

        if (request.wasCancelled) {
            return;
        }

        if (!TB.has(response, 'success.data.projects')) {
            return;
        }

        return Project.makeMany([...response.success.data.projects]);
    }

    async resetCandidateQueryDataForAgency(project, transformPageCallback = (page) => page) {

        TB.queryClient.setQueriesData({
            predicate: ({queryKey}) => {
                let params = queryKey?.[1] || {};
                return queryKey?.[0] === 'agencyMatches' && params.project === project.id;
            }
            // inactive: false
        }, page => {
            if (!page) return page;
            const talentKey = page.talent ? 'talent' : 'agencys'
            page[talentKey] = TB.map([...page[talentKey]], talent => {
                if (talent.id === this.id) {
                    return this;
                }
                return talent;
            });

            return transformPageCallback(page);
        });

        return this
    }

    /*
    |--------------------------------------------------------------------------
    | Agency Interviews
    |--------------------------------------------------------------------------
    */
    async requestInterview(project) {
        let responseData = await this.constructor.runProjectRequest(
            project, 'RequestInterviewForProjectRequest', 'get', `/${this.id}/request-interview`
        );

        if (!responseData) {
            return;
        }

        this.interview_requested_at = new Date();

        Agency.refreshCacheFor(
            this
        );
        return this;
    }

    interviewRequestedAt() {
        if (!this.interview_requested_at) {
            return false
        }

        return TB.moment(this.interview_requested_at).format('ll');
    }

    hasRequestedInterview() {
        if (TB.isDefined(this.interview_requested_at)) {
            return true
        }

        return false
    }

    /*
    |--------------------------------------------------------------------------
    | Request Proposal from Agency
    |--------------------------------------------------------------------------
    */

    async assignTo(project) {
        let responseData = await this.constructor.runProjectRequest(
            project, 'AssignToProjectRequest', 'post', `/${this.id}/assign`
        );

        if (!responseData) {
            return;
        }
        let updatedProject = Project.make({...project})
        if (responseData.project) {
            updatedProject = Project.make({...responseData.project})
        }

        if (responseData.agency) {
            let agency = Agency.normalizeScope({...this,...responseData.agency}, updatedProject);

            await Agency.resetCandidateQueryDataForProject(agency,updatedProject);

            return agency;
        }

        return false;
    }

    async unassignFrom(project) {
        let responseData = await this.constructor.runProjectRequest(
            project, 'UnassignFromProjectRequest', 'post', `/${this.id}/unassign`
        );

        if (!responseData) {
            return;
        }

        let updatedProject = Project.make({...project})
        if (responseData.project) {
            updatedProject = Project.make({...responseData.project})
        }

        if (responseData.agency) {
            let agency = Agency.normalizeScope({...this,...responseData.agency}, updatedProject);


            await Agency.resetCandidateQueryDataForProject(agency,updatedProject);

            return agency;
        }

        return false;
    }

    async requestProposalFor(project) {
        let responseData = await this.constructor.runProjectRequest(
            project, 'RequestProposalForProjectRequest', 'post', `/${this.id}/request-proposal`
        );

        if (!responseData) {
            return;
        }

        if (responseData.project) {
            let updatedProject = Project.make({...responseData.project})
            await Project.refreshCacheFor(
                updatedProject
            );
            this.proposal_requested_at = TB.moment().format();
            Agency.refreshCacheFor(
                this
            );
        } else if (responseData.agency) {
            let agency = Agency.make(responseData.agency)
            Agency.refreshCacheFor(
                agency
            );
            return agency;
        }

        return this;
    }

    async cancelRequestProposalFor(project) {
        let responseData = await this.constructor.runProjectRequest(
            project, 'CancelRequestProposalForProjectRequest', 'post', `/${this.id}/cancel-proposal-request`
        );

        if (!responseData) {
            return;
        }

        if (responseData.project) {
            let updatedProject = Project.make({...responseData.project})
            await Project.refreshCacheFor(
                updatedProject
            );
            this.proposal_requested_at = null;
            this.proposal_path = null;
            Agency.refreshCacheFor(
                this
            );
        } else if (responseData.agency) {
            let agency = Agency.make(responseData.agency)
            Agency.refreshCacheFor(
                agency
            );
            return agency;
        }

        return this;
    }

    /*
   |--------------------------------------------------------------------------
   | Add/Remove to/from Shortlist
   |--------------------------------------------------------------------------
   */
    async addToCandidates(project) {
        let responseData = await this.constructor.runProjectRequest(
            project, 'AddToProjectCandidatesRequest', 'post', `/${this.id}/shortlist`
        );

        if (!TB.has(responseData, 'agency')) {
            throw new Error("Something Went Wrong")
        }

        let agency = Agency.make(responseData.agency);

        let shortlisted_candidates_count = (project.shortlisted_candidates_count || 0) + 1;
        let proposals_requested_at = project.proposals_requested_at || new Date();
        let updatedProject = {...project, shortlisted_candidates_count, proposals_requested_at}
        await Project.refreshCacheFor(updatedProject);

        // await agency.resetCandidateQueryDataForAgency();

        return agency;
    }

    async removeFromCandidates(project, append = '') {
        let params = '?';
        if (this.declinedPosition() && !this.job_candidate?.was_disliked) {
            params += 'self_disliked=1&'
        }
        params += append
        let responseData = await this.constructor.runProjectRequest(
            project, 'RemoveFromProjectCandidatesRequest',
            'post',
            `/${this.id}/undo-shortlist` + params
        ).catch(error => console.warn(error));

        if (!TB.has(responseData, 'agency')) {
            if (TB.has(this.constructor.RemoveFromProjectCandidatesRequest.response, 'error.data.has_confirmed_interview_cancellation')) {

                let confirmInterviewCancellation = await TB.sysAlert('client.pending_interview_cancellation_on_removing_candidate');
                if (confirmInterviewCancellation) {
                    return this.removeFromCandidates(project, 'has_confirmed_interview_cancellation=true')
                }
            }
            return false;
        }


        let shortlisted_candidates_count = (project.shortlisted_candidates_count || 0) - 1;
        let proposals_requested_at = project.proposals_requested_at;
        if (!shortlisted_candidates_count) {
            proposals_requested_at = null;
        }
        let updatedProject = {...project, shortlisted_candidates_count, proposals_requested_at}
        await Project.refreshCacheFor(updatedProject);

        return Agency.make(responseData?.agency);
    }

    requestedProposalAt(format = true) {
        if (!this.proposal_requested_at) {
            return;
        }

        let requestedAt = TB.moment(this.proposal_requested_at);
        if (!format) {
            return requestedAt;
        }

        return requestedAt.format('MMM D YYYY');
    }

    /*
    |--------------------------------------------------------------------------
    | Add/Remove Agency to/from Favorites
    |--------------------------------------------------------------------------
    */

    async addToFavorites(project) {
        let user = TB.auth().user();
        if (!user
            || !user.hasRegisteredClientOrg()) {
            return;
        }


        this.constructor.AddToFavoritesRequest = TB.request(
            TB.api_endpoint(`/api/clients/${user.clientOrg().id}/agencys/${this.id}/favorite`)
        );

        let response = await this.constructor.AddToFavoritesRequest.post().catch(console.warn);

        if (!response
            || !response.success
            || !response.success.data) {
            this.constructor.AddToFavoritesRequest.didHandleError = await this.constructor.AddToFavoritesRequest.handleError();
            if (this.constructor.AddToFavoritesRequest.didHandleError
                && this.constructor.AddToFavoritesRequest.shouldRerun) {
                return this.addToFavorites();
            }

            return;
        }

        this.is_favorite = true;

        if (project) {
            this.constructor.refreshCacheFor(
                project, this
            );
        }


        return this;
    }

    async removeFromFavorites(project) {
        let user = TB.auth().user();
        if (!user
            || !user.hasRegisteredClientOrg()) {
            return;
        }


        this.constructor.RemoveFromFavoritesRequest = TB.request(
            TB.api_endpoint(`/api/clients/${user.clientOrg().id}/agencys/${this.id}/unfavorite`)
        );

        let response = await this.constructor.RemoveFromFavoritesRequest.post().catch(console.warn);

        if (!response
            || !response.success
            || !response.success.data) {
            this.constructor.RemoveFromFavoritesRequest.didHandleError = await this.constructor.RemoveFromFavoritesRequest.handleError();
            if (this.constructor.RemoveFromFavoritesRequest.didHandleError
                && this.constructor.RemoveFromFavoritesRequest.shouldRerun) {
                return this.addToFavorites(project);
            }

            return;
        }

        this.is_favorite = false;

        if (project) {
            this.constructor.refreshCacheFor(
                project, this
            );
        }

        return this;
    }

    /*
    |--------------------------------------------------------------------------
    | Add/Remove Agency to/from Shortlist
    |--------------------------------------------------------------------------
    */

    async addToShortlist(project) {
        let responseData = await this.constructor.runProjectRequest(
            project, 'AddToProjectShortlistRequest', 'post', `/${this.id}/shortlist`
        );

        if (!responseData) {
            return;
        }

        this.is_shortlisted = true;
        this.is_favorite = false;

        if (responseData.project) {
            let updatedProject = Project.make({...responseData.project})
            this.constructor.refreshCacheFor(
                updatedProject, this
            );
        } else {
            this.constructor.refreshCacheFor(
                project, this
            );
        }

        return this;
    }

    async removeFromShortlist(project) {
        let responseData = await this.constructor.runProjectRequest(
            project, 'RemoveFromProjectShortlistRequest', 'post', `/${this.id}/shortlist/remove`
        );

        if (!responseData) {
            return;
        }

        this.is_shortlisted = false;

        if (responseData.project) {
            let updatedProject = Project.make({...responseData.project})
            this.constructor.refreshCacheFor(
                updatedProject, this
            );
        } else {
            this.constructor.refreshCacheFor(
                project, this
            );
        }

        return this;
    }
    /*
        |--------------------------------------------------------------------------
        | Add/Remove to/from Liked
        |--------------------------------------------------------------------------
        */
    async addToLiked(project)
    {
        let responseData = await this.constructor.runProjectRequest(
            project, 'AddToProjectLikedRequest', 'post', `/${this.id}/like`
        );

        if (!TB.has(responseData, 'agency')) {
            return false;
        }
        let updatedProject = Project.make({...project})
        if (responseData.project) {
            updatedProject = Project.make({...responseData.project})
        }

        if (responseData.agency) {
            let agency = Agency.normalizeScope({...this,...responseData.agency}, updatedProject);

            await Agency.resetCandidateQueryDataForProject(agency,updatedProject);
            await agency.resetCandidateQueryDataForAgency(updatedProject, page => {
                if (!agency.job_candidate?.likes?.length) {
                    page.liked_total = page.liked_total + 1;
                }
                page.self_liked_total = page.self_liked_total + 1;
                return page;
            });
            return agency;
        }

        return false;
    }

    async removeFromLiked(project)
    {
        let responseData = await this.constructor.runProjectRequest(
            project, 'RemoveFromProjectLikedRequest', 'post', `/${this.id}/undo-like`
        );

        if (!TB.has(responseData, 'agency')) {
            return false;
        }
        let updatedProject = Project.make({...project})
        if (responseData.project) {
            updatedProject = Project.make({...responseData.project})
        }

        if (responseData.agency) {
            let agency = Agency.normalizeScope({...this,...responseData.agency}, updatedProject);

            await Agency.resetCandidateQueryDataForProject(agency,updatedProject);
            await agency.resetCandidateQueryDataForAgency(updatedProject, page => {
                if (agency.job_candidate?.likes?.length === 1) {
                    page.liked_total = page.liked_total - 1;
                }
                page.self_liked_total = page.self_liked_total - 1;
                return page;
            });
            return agency;
        }

        return false;
    }
    /*
    |--------------------------------------------------------------------------
    | Add/Remove Agency to/from Archive
    |--------------------------------------------------------------------------
    */

    async addToArchive(project) {
        let responseData = await this.constructor.runProjectRequest(
            project, 'AddToProjectArchiveRequest', 'post', `/${this.id}/dislike`
        );

        if (!responseData?.agency) {
            return;
        }

        let updatedProject = Project.make({...project})
        if (responseData.project) {
            updatedProject = Project.make({...responseData.project})
        }

        if (responseData.agency) {
            let agency = Agency.normalizeScope({...this,...responseData.agency}, updatedProject);

            await Agency.resetCandidateQueryDataForProject(agency,updatedProject);
            await agency.resetCandidateQueryDataForAgency(updatedProject, page => {
                page.self_disliked_total = page.self_disliked_total + 1;
                page.disliked_total = page.disliked_total + 1;
                return page;
            });
            return agency;
        }

        return false;
    }

    async removeFromArchive(project) {
        let responseData = await this.constructor.runProjectRequest(
            project, 'RemoveFromProjectArchiveRequest', 'post', `/${this.id}/undo-dislike`
        );


        if (!responseData?.agency) {
            return;
        }

        let updatedProject = Project.make({...project})
        if (responseData.project) {
            updatedProject = Project.make({...responseData.project})
        }

        if (responseData.agency) {
            let agency = Agency.normalizeScope({...this,...responseData.agency}, updatedProject);

            await Agency.resetCandidateQueryDataForProject(agency,updatedProject);
            await agency.resetCandidateQueryDataForAgency(updatedProject, page => {
                page.self_disliked_total = page.self_disliked_total - 1;
                page.disliked_total = page.disliked_total - 1;
                return page;
            });
            return agency;
        }

        return false;
    }

    static async resetCandidateQueryDataForProject(updatedAgency, project = null) {
        if (!updatedAgency) {
            return;
        }

        if (project) {
            await Project.refreshCacheFor(
                project
            );
        }

        TB.queryClient.setQueriesData({
            predicate: ({queryKey}) => {
                let params = queryKey?.[1] || {};
                return queryKey?.[0] === 'agencyMatches' && params.project === project?.id;
            }
        }, page => {
            if(!page) return page;
            const talentKey = page.talent ? 'talent' : 'agencys'
            page[talentKey] = TB.map([...page[talentKey]], talent => {
                if (talent.id === updatedAgency.id) {
                    return updatedAgency;
                }
                return talent;
            });

            return page;
        });
        return updatedAgency
    }
    /*
    |--------------------------------------------------------------------------
    | Project Scope
    |--------------------------------------------------------------------------
    */
    proposalDocument = () => {
        return this.latest_proposal
    }

    isAgency() {
        return this.type === 'Agency'
    }
    canConfirmScope = () => {
        let missingDisciplines = TB.filter(this.disciplines, ['talent_opp', undefined])
        if (missingDisciplines?.length > 0) {
            return false
        }
        let missingDeliverableHours = TB.find(TB.flatMap(this?.phases, 'deliverables'), del => del?.total_agency_hours <= 0);

        return missingDeliverableHours?.length <= 0;
    }

    canEditAgencyScope() {
        return !this.statusIsRejected() && !this.statusIsWithdrawn() && !this.statusIsApproved()
    }
    canAcceptPayout = () => {
        if (!this.hasConfirmedScope()) {
            return false;
        }

        return this.total_accepted_talent_opps >= this.total_talent_opps
    }
    static normalizeScope = (agencyData, project) => {

        if (!(agencyData instanceof Agency)) {
            agencyData = Agency.make({...agencyData})
        }
        // let talentUsers = TB.map(agencyData.job_candidate.talent_opps || [], (user) => {
        //     let userPosition = TB.find(agencyData.positions, ['id', user.id]);
        //
        //     return User.make({
        //         ...userPosition,
        //         ...user
        //     })
        // })
        let phaseDisciplinesById = TB.groupBy(
            TB.flatMap(
                TB.flatMap(
                    TB.filter(
                        TB.flatMap(
                            project?.phases || [],
                            'deliverables'
                        ), ['is_active', true]
                    ), 'activities'
                ), 'disciplines'
            ),
            'id')

        let validProjectDisciplines = TB.map([...(project.disciplines || [])], discipline => {
            let active_hours = 0;

            if (phaseDisciplinesById[discipline.id]) {
                active_hours = TB.sumBy(phaseDisciplinesById[discipline.id], dis => parseInt(dis.total_hours || dis.pivot?.total_hours || 0))
            }

            return {...discipline, active_hours};
        })

        validProjectDisciplines = TB.filter(validProjectDisciplines, dis => {
            let total_hours = dis.total_hours || dis.pivot?.total_hours || 0;
            return total_hours > 0;
        })
        let disciplines = TB.map(validProjectDisciplines, (discipline, dIndex) => {
            let talent_opp = TB.find(agencyData.job_candidate.talent_opps, opp => {
                return opp.status !== Opportunity.Statuses.Lost && TB.find(opp.disciplines, {id: discipline.id})
            });

            // console.log('talent_opps', talent_opp);
            // talent_opp = TB.first(TB.shuffle(talent_opp))
            if (talent_opp) {
                let talentDiscipline = TB.find(talent_opp.disciplines, ['id', discipline.id]) || {};

                talent_opp = {
                    ...talent_opp,
                    opp_discipline: talentDiscipline,
                    discipline_index: discipline.display_index,
                }
            }

            return {
                ...discipline,
                agency_discipline_index: dIndex + 1,
                talent_opp,
                estimated_agency_cost: talent_opp?.opp_discipline?.payout_amount || 0,
                estimated_platform_cost: talent_opp?.opp_discipline?.platform_cost || 0,
                total_agency_hours: talent_opp?.opp_discipline?.total_hours || 0,
                estimated_proposed_agency_cost: talent_opp?.opp_discipline?.proposed_payout_amount || talent_opp?.opp_discipline?.payout_amount || 0,
                estimated_proposed_platform_cost: talent_opp?.opp_discipline?.proposed_platform_cost || talent_opp?.opp_discipline?.platform_cost || 0,
                total_proposed_agency_hours: talent_opp?.opp_discipline?.proposed_total_periods || talent_opp?.opp_discipline?.total_hours || 0,
                market_rate: talent_opp?.opp_discipline?.hourly_rate || 0
            }
        })
        disciplines = TB.filter(disciplines, dis => {
            return dis.active_hours > 0 || dis.talent_opp;
        })

        let phases = TB.map(project.phases, (phase, pIndex) => {
            let deliverables = TB.map(phase.deliverables, deliverable => {
                let activities = TB.map(deliverable.activities, activity => {
                    // TODO Change after backend changes for agency scoping
                    let validActivityDisciplines = TB.filter(activity.disciplines, dis => {
                        let total_hours = dis.total_hours || dis.pivot?.total_hours || 0;
                        return total_hours > 0;
                    })
                    let disciplines = TB.map(validActivityDisciplines, discipline => {
                        let talent_opp = TB.find(agencyData.job_candidate.talent_opps, opp => {
                                return opp.status !== Opportunity.Statuses.Lost && TB.find(opp.disciplines, userDiscipline => {
                                    return userDiscipline.id === discipline.id && TB.find(userDiscipline.deliverable_activities || [], ['id', activity.id])
                                })
                        })

                        if (talent_opp) {
                            let deliverableDiscipline = TB.find(talent_opp.disciplines, ['id', discipline.id])

                            let hourly_rate = parseFloat(deliverableDiscipline?.hourly_rate || UserDiscipline.rateForDiscipline(discipline.id));

                            let total_hours = TB.find(deliverableDiscipline.deliverable_activities || [],['id', activity.id]).total_hours;

                            let estimated_agency_cost = Math.ceil(hourly_rate) * total_hours;

                            let estimated_platform_cost = (Math.ceil(hourly_rate) * (1 + (agencyData.job_candidate.percent_markup || 0))) * total_hours;

                            talent_opp = {
                                ...talent_opp,
                                opp_discipline: deliverableDiscipline,
                                estimated_agency_cost,
                                estimated_platform_cost,
                                total_hours,
                                discipline_index: discipline.display_index,
                                activity_index: activity.display_index,
                                deliverable_index: deliverable.display_index,
                                phase_index: phase.display_index,
                            }
                        }

                        return {
                            ...discipline,
                            talent_opp,
                            estimated_agency_cost: talent_opp?.estimated_agency_cost || 0,
                            estimated_platform_cost: talent_opp?.estimated_platform_cost || 0,
                            total_agency_hours: talent_opp?.total_hours || 0
                        }
                    })

                    let activeDisciplines = TB.filter(disciplines, ['is_active', true]);
                    // TODO Change after backend changes for agency scoping
                    activeDisciplines = TB.filter(activeDisciplines, dis => {
                        let total_hours = dis.total_hours || dis.pivot?.total_hours || 0;
                        return total_hours > 0;
                    })
                    return {
                        ...activity,
                        disciplines: activeDisciplines,
                        estimated_agency_cost: TB.sumBy(activeDisciplines, 'estimated_agency_cost') || 0,
                        estimated_platform_cost: TB.sumBy(activeDisciplines, 'estimated_platform_cost') || 0,
                        total_agency_hours: TB.sumBy(activeDisciplines, 'total_agency_hours') || 0
                    }
                })

                let activeActivities = TB.filter(activities, act => act.disciplines?.length)


                return {
                    ...deliverable,
                    activities: activeActivities,
                    estimated_agency_cost: TB.sumBy(activeActivities, 'estimated_agency_cost') || 0,
                    estimated_platform_cost: TB.sumBy(activeActivities, 'estimated_platform_cost') || 0,
                    total_agency_hours: TB.sumBy(activeActivities, 'total_agency_hours') || 0
                }
            })
            let phaseModel = ProjectPhase.make({...phase});

            let activeDeliverables = TB.filter(phaseModel.deliverables, ['is_active', true])
            activeDeliverables = TB.filter(activeDeliverables, del => del.activities?.length)
            let total_hours = TB.sumBy(activeDeliverables, 'total_hours');
            let estimated_cost = TB.sumBy(activeDeliverables, 'estimated_cost');

            let display_index = pIndex + 1

            return ProjectPhase.make({
                ...phase,
                deliverables,
                total_hours,
                estimated_cost,
                display_index,
                estimated_agency_cost: TB.sumBy(deliverables, 'estimated_agency_cost') || 0,
                estimated_platform_cost: TB.sumBy(deliverables, 'estimated_platform_cost') || 0,
                total_agency_hours: TB.sumBy(deliverables, 'total_agency_hours') || 0
            })
        })

        phases = TB.filter(phases, phase => phase.deliverables?.length)
        return this.make({...agencyData, phases, disciplines})
    }

    /*
    |--------------------------------------------------------------------------
    | Availability
    |--------------------------------------------------------------------------
    */

    hasRequiredDisciplinesFor(project) {
        let disciplines = project.requiredDisciplines();
        let memberDisciplines = TB.groupBy(this.positions, 'discipline.id');

        for (let discipline of disciplines) {
            if (!memberDisciplines[discipline.id]) {
                return false;
            }
        }

        return true;
    }

    hasDiscipline(discipline) {
        let memberDisciplines = TB.groupBy(this.positions, 'discipline.id');

        return memberDisciplines[discipline.id];
    }


}